module.exports = __webpack_public_path__ + "static/media/DSC01587.8988f399.jpeg";